import React, { BaseSyntheticEvent, useEffect } from "react";
import {
  ComponentProps,
  ComponentWidth,
  KontentRichText,
} from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { SearchInput } from "../../elements/SearchInput/SearchInput";
import * as styles from "./ArboretumSearch.module.css";
import { useForm } from "react-hook-form";
import { Link } from "../../elements/Link/Link";
import { ImageItem } from "@kontent-ai/gatsby-components/dist/image-element";
import CSS from "csstype";
import { navigate } from "gatsby";

interface Props extends ComponentProps, ComponentWidth {
  title: string;
  titleColor?: string;
  subhead?: string;
  subheadColor?: string;
  bodyCopy?: KontentRichText;
  bodyCopyColor?: string;
  backgroundColor?: string;
  backgroundImage?: {
    item: ImageItem;
    alt: string;
  };
  backgroundImagePlacement?: "top_left" | "top_right";
}

interface FormValues {
  searchText: string;
}

const defaultValues = {
  searchText: "",
};

export const ArboretumSearch: React.FC<Props> = ({
  title,
  titleColor,
  subhead,
  subheadColor,
  bodyCopy,
  bodyCopyColor,
  backgroundColor,
  backgroundImage,
  backgroundImagePlacement,
  width = "full",
  hideOnMobile,
  anchor,
  id,
}) => {
  const handleArboretumSearchFormSubmit = (
    data: FormValues,
    e?: BaseSyntheticEvent<object, any, any> | undefined
  ): void => {
    navigate(
      `/about/arboretum/arboretum-search?q=${encodeURI(data.searchText)}`,
      {
        state: { data },
      }
    );
  };

  const handleArboretumSearchFormError = (
    errors: {},
    e?: BaseSyntheticEvent<object, any, any> | undefined
  ): void => {
    console.log("Error", errors, e);
  };
  let contentClassName = styles.container;
  if (width === "contained") {
    contentClassName += ` ${styles.contained}`;
  }

  const titleStyles = titleColor ? { color: titleColor } : {};
  const subheadStyles = subheadColor ? { color: subheadColor } : {};
  const bodyStyles = bodyCopyColor ? { color: bodyCopyColor } : {};
  const sectionStyles: CSS.Properties = {};

  if (backgroundColor) {
    sectionStyles.backgroundColor = backgroundColor;
  }
  if (backgroundImage?.item?.url) {
    sectionStyles.backgroundImage = `url(${backgroundImage.item.url})`;
  }
  if (backgroundImagePlacement === "top_left") {
    sectionStyles.backgroundPosition = "top left";
  }

  const {
    control,
    register,
    watch,
    formState: { isDirty, errors },
    getValues,
    handleSubmit,
    clearErrors,
  } = useForm({ defaultValues });

  const watchSearchText = watch("searchText", "");

  useEffect(() => {
    if (isDirty && errors.searchText) {
      clearErrors("searchText");
    }
  }, [isDirty]);

  return (
    <SectionWrapper id={id} anchor={anchor} hideOnMobile={hideOnMobile}>
      <div style={sectionStyles} className={styles.arboretumSearch}>
        <div className={contentClassName}>
          <form
            onSubmit={handleSubmit(
              handleArboretumSearchFormSubmit,
              handleArboretumSearchFormError
            )}
          >
            <div className={styles.mainFormSection}>
              <div className={styles.content}>
                <h2 style={titleStyles} data-kontent-element-codename="title">
                  {title}
                </h2>
                {subhead && (
                  <p
                    style={subheadStyles}
                    className={styles.subhead}
                    data-kontent-element-codename="subhead"
                  >
                    {subhead}
                  </p>
                )}
                {bodyCopy && (
                  <div
                    style={bodyStyles}
                    data-kontent-element-codename="simple_rte__text"
                  >
                    <CustomRichTextElement content={bodyCopy} />
                  </div>
                )}
              </div>
              <div className={styles.formWrap}>
                <div>
                  <SearchInput
                    placeHolder="SEARCH"
                    color="green"
                    borderColor={"green"}
                    inputProps={register("searchText")}
                    disableSubmit={!watchSearchText}
                  />
                  <div className={styles.advancedWrap}>
                    <Link to={"/about/arboretum/arboretum-search"}>
                      Advanced Search
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </SectionWrapper>
  );
};
